import { Fragment, useCallback, useMemo, useRef } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useState, useEffect } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {
  Box,
  Card,
  CircularProgress,
  Link,
  Avatar,
  Button,
  useMediaQuery,
  useTheme,
  Tooltip,
  Alert,
  AlertTitle,
} from "@mui/material";
import {
  Grid,
  Typography,
  Divider,
  TabsWrapper,
  TabContent,
  Spacer,
} from "./style";
import Contatti from "./clientDetails/Contatti";
import Legale from "./clientDetails/Legale";
import StatoAssicurativo from "./clientDetails/StatoAssicurativo";
import Preventivi from "../rcAutoDetails2/tabs/preventivi";
import ClienteCard from "./clientDetails/Cliente";
import VeicoloCard from "./clientDetails/Veicolo";
import Veicolo from "./tabs/Veicolo";
import Cliente from "./tabs/Cliente";
import Persona from "./tabs/Persona";
import RiskRadar from "./tabs/RiskRadar";
import { ArrowBack, Save } from "@mui/icons-material";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import {
  FormRCAutoDetailsProvider,
  useFormRCAutoDetails,
} from "./rcautoContext";
import {
  personaFisicaClienteFields,
  personaGiuridicaClienteFields,
  personaGiuridicaLegaleFields,
  veicoloFields,
} from "../rcAutoDetails2/constants";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../../redux/slices/snackbar";
import { API_BASE_URL } from "../../../config";
import Portante from "./tabs/Portante";
import { validateTarga } from "../rcAuto/nuovoPreventivo/helpers";
import PopoverButtons from "./lib/PopoverButtons";
import useAuth from "../../../hooks/useAuth";
import Polizze from "./tabs/preventivi/Polizza";
import { ChevronLeft } from "react-feather";
import Controlli from "./tabs/Controlli";

const RCAutoDetailsProfileComponent = () => {
  const { formState, dispatch } = useFormRCAutoDetails();
  const { idTarga, idUidPrev } = useParams();
  const theme = useTheme();

  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [data, setData] = useState([]);
  const [veicolo, setVeicolo] = useState({});
  const [disabledFields, setDisabledFields] = useState({
    veicolo: {},
    legale: {},
    cliente: {},
  });
  const [tabs, setTabs] = useState({});
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [currentRef, setCurrenRef] = useState(null);
  const buttonRef = useRef({});

  const [isSaved, setIsSaved] = useState(false);

  const { getData } = useAuth();
  const [nazioni, setNazioni] = useState([]);
  const [provincie, setProvincie] = useState([]);
  const [toponomie, setToponomie] = useState([]);
  const [datiComuniLegale, setDatiComuniLegale] = useState([]);
  const [datiCapLegale, setDatiCapLegale] = useState([]);
  const [datiComuniNascitaLegale, setDatiComuniNascitaLegale] = useState([]);
  const [datiComuniCliente, setDatiComuniCliente] = useState([]);
  const [datiComuniNascitaCliente, setDatiComuniNascitaCliente] = useState([]);
  const [datiCapCliente, setDatiCapCliente] = useState([]);
  const [contatti, setContatti] = useState([]);

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const location = useLocation();

  const dispatchSnackbar = useDispatch();

  // Snackbar helper
  const handleSnackbar = (message, severity) => {
    dispatchSnackbar(showSnackbar({ message, severity }));
  };

  const handleClickButton = (button) => {
    if (button === "sV") {
      handleSave();
      // your save logic here
    } else if (button === "rT") {
      console.log("Rilancia Visura clicked → run visura logic");
      // your "rilancia visura" logic
    } else {
      console.log("Rilancia Preventivi clicked → run preventivi logic");
      // your "rilancia preventivi" logic
    }
  };

  const getTabDataset = (key) => {
    if (!data || !data.tabs) return;
    const tab = data.tabs.find((item) => item.hasOwnProperty(key));
    return tab ? tab[key] : undefined;
  };

  const updateNazioni = async () => {
    try {
      const data = await getData({ action: "nazioni" });
      console.log(data);
      setNazioni(data);
    } catch (error) {
      console.error("Errore nel caricamento delle nazioni:", error);
    }
  };

  const updateProvincie = () => {
    let arrProvincie = [];
    getData({ action: "provincie" }).then((data) => {
      for (let i = 0; i < data.length; i++) {
        arrProvincie.push({
          value: data[i].ProvinciaSigla,
          label: data[i].Provinciaestesa,
        });
      }
      setProvincie(arrProvincie);
      return data;
    });
  };

  const updateComune = (provincia, setComuni) => {
    let arrComuni = [];
    return getData({ action: "comuni", provRes: provincia }).then((data) => {
      for (let i = 0; i < data.length; i++) {
        arrComuni.push({
          value: data[i].Codice_comune,
          label: data[i].Comune,
        });
      }
      if (Array.isArray(setComuni)) {
        setComuni.forEach((s) => s(arrComuni));
      } else {
        setComuni(arrComuni);
      }
      return arrComuni;
    });
  };

  const updateCap = (value, setCap) => {
    let arrCap = [];
    return getData({ action: "cap", cap: value }).then((data) => {
      for (let i = 0; i < data.length; i++) {
        arrCap.push({ value: data[i].CAP, label: data[i].CAP });
      }
      if (Array.isArray(setCap)) {
        setCap.forEach((s) => s(arrCap));
      } else {
        setCap(arrCap);
      }
      return arrCap;
    });
  };

  const getToponomie = async () => {
    try {
      const data = await getData({ action: "toponimi" });
      setToponomie(data);
    } catch (error) {
      console.error("Errore nel caricamento delle toponomie:", error);
    }
  };

  async function rcAutoGetDetails() {
    const token = sessionStorage.getItem("token");

    try {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
      };

      let endpoint = `${API_BASE_URL}/api/rcAuto/details/${idTarga}`;

      if (idUidPrev) {
        endpoint += `?idUidPrev=${idUidPrev}`;
      }

      const response = await fetch(endpoint, requestOptions);
      const res = await response.json();

      if (res.status === -1) {
        sessionStorage.clear();
        navigate("/auth/sign-in");
        handleSnackbar(res.message, "error");
      }
      if (res.status === 0) {
        navigate("/private");
        handleSnackbar(res.message, "error");
        return;
      }

      setData(res);
      const preventiviList =
        res.tabs.find((t) => t.Preventivi)?.Preventivi || {};

      dispatch({
        type: "set_data",
        veicolo: res.tabs[0]?.Veicolo?.Veicolo[0],
        cliente: res.tabs[1]?.Cliente,
        legale: res.tabs[1]?.legale ?? {},
        preventivi: preventiviList,
        errors: {
          Veicolo: {},
          Cliente: {},
          Legale: {},
        },
      });
      const isPersonaGiuridica = !!res.tabs[1]?.legale;
      const statoAssicurativo = res.tabs[0]?.Veicolo?.idStatoAssicurativo;

      const veicoloObj = res.tabs[0]?.Veicolo?.Veicolo[0] || {};
      const clienteObj = res.tabs[1]?.Cliente || {};
      const legaleObj = res.tabs[1]?.legale || {};

      const clienteFields = isPersonaGiuridica
        ? personaGiuridicaClienteFields
        : personaFisicaClienteFields;

      dispatch({
        type: "set_errors",
        scope: "Veicolo",
        payload: validateFields(veicoloObj, veicoloFields, statoAssicurativo),
      });
      dispatch({
        type: "set_errors",
        scope: "Cliente",
        payload: validateFields(clienteObj, clienteFields),
      });
      if (isPersonaGiuridica) {
        dispatch({
          type: "set_errors",
          scope: "Legale",
          payload: validateFields(legaleObj, personaGiuridicaLegaleFields),
        });
      }

      const getDisabledFromApi = (obj) => {
        const disabled = Object.keys(obj).filter(
          (key) =>
            obj[key] !== "" &&
            obj[key] !== null &&
            obj[key] !== undefined &&
            key !== "slResIndirizzoVia" &&
            key !== "slResIndirizzo" &&
            key !== "slResCap" &&
            key !== "slResCivico",
        );

        // special case: cf and piva → if either has an initial value, both disabled
        if ((obj.cf && obj.cf !== "") || (obj.piva && obj.piva !== "")) {
          disabled.push("cf", "piva");
        }

        return disabled;
      };
      setDisabledFields({
        veicolo: getDisabledFromApi(veicoloObj),
        cliente: getDisabledFromApi(clienteObj),
        legale: getDisabledFromApi(legaleObj),
      });

      const tbs = {};
      res.tabs.forEach((obj) => {
        const chiave = Object.keys(obj)[0];
        tbs[chiave] = obj[chiave];
      });

      setVeicolo(res.tabs[0]?.Veicolo?.Veicolo[0]);

      setTabs(tbs);
      dispatch({ type: "SET_ACTIVE_TAB", payload: res.defaultTab });

      // Consolidate lookup tasks to avoid duplicate calls
      const provinceTasks = {};
      const capTasks = {};

      const addProvinceTask = (prov, setter) => {
        if (!prov) return;
        if (!provinceTasks[prov]) provinceTasks[prov] = [];
        provinceTasks[prov].push(setter);
      };

      const addCapTask = (comune, setter) => {
        if (!comune) return;
        if (!capTasks[comune]) capTasks[comune] = [];
        capTasks[comune].push(setter);
      };

      // Residence and Birth for Client
      addProvinceTask(clienteObj?.slResProvincia, setDatiComuniCliente);
      addCapTask(clienteObj?.slResComuneCodice, setDatiCapCliente);
      addProvinceTask(
        clienteObj?.nascitaProvincia,
        setDatiComuniNascitaCliente,
      );

      // Residence and Birth for Legale
      if (isPersonaGiuridica) {
        addProvinceTask(legaleObj?.slResProvincia, setDatiComuniLegale);
        addCapTask(legaleObj?.slResComuneCodice, setDatiCapLegale);
        addProvinceTask(
          legaleObj?.nascitaProvincia,
          setDatiComuniNascitaLegale,
        );
      }

      // Execute unique province calls
      Object.entries(provinceTasks).forEach(([prov, setters]) => {
        updateComune(prov, setters).then((options) => {
          if (clienteObj?.slResProvincia === prov) {
            const isValid = options.some(
              (o) => String(o.value) === String(clienteObj.slResComuneCodice),
            );
            if (clienteObj.slResComuneCodice && !isValid) {
              dispatch({
                type: "set_errors",
                scope: "Cliente",
                payload: {
                  ...formState.errors.Cliente,
                  slResComuneCodice: "Campo obbligatorio",
                },
              });
            }
          }
          if (isPersonaGiuridica && legaleObj?.slResProvincia === prov) {
            const isValid = options.some(
              (o) => String(o.value) === String(legaleObj.slResComuneCodice),
            );
            if (legaleObj.slResComuneCodice && !isValid) {
              dispatch({
                type: "set_errors",
                scope: "Legale",
                payload: {
                  ...formState.errors.Legale,
                  slResComuneCodice: "Campo obbligatorio",
                },
              });
            }
          }
        });
      });

      // Execute unique CAP calls
      Object.entries(capTasks).forEach(([comune, setters]) => {
        updateCap(comune, setters).then((options) => {
          if (clienteObj?.slResComuneCodice === comune) {
            const isValid = options.some(
              (o) => String(o.value) === String(clienteObj.slResCap),
            );
            if (clienteObj.slResCap && !isValid) {
              dispatch({
                type: "set_errors",
                scope: "Cliente",
                payload: {
                  ...formState.errors.Cliente,
                  slResCap: "Campo obbligatorio",
                },
              });
            }
          }
          if (isPersonaGiuridica && legaleObj?.slResComuneCodice === comune) {
            const isValid = options.some(
              (o) => String(o.value) === String(legaleObj.slResCap),
            );
            if (legaleObj.slResCap && !isValid) {
              dispatch({
                type: "set_errors",
                scope: "Legale",
                payload: {
                  ...formState.errors.Legale,
                  slResCap: "Campo obbligatorio",
                },
              });
            }
          }
        });
      });

      // Nations call (only once if needed by either)
      if (
        clienteObj?.nascitaStatoEstero === 1 ||
        (isPersonaGiuridica && legaleObj?.nascitaStatoEstero === 1)
      ) {
        updateNazioni();
      }

      getData({ action: "tipologiacontatti" }).then((data) => {
        setContatti(data);
      });
      updateProvincie();
      getToponomie();

      setIsLoading(false);
    } catch (error) {
      return error;
    }
  }
  useEffect(() => {
    rcAutoGetDetails();
  }, [idTarga]);

  const handleTabChange = (event, newValue) => {
    dispatch({ type: "SET_ACTIVE_TAB", payload: newValue });
    if (newValue !== "Cliente") {
      dispatch({ type: "SET_MODIFICA_MODE", payload: false });
    }
  };
  const validateFields = (data, fields, options = {}) => {
    const { statoAssicurativo = null, lookups = {} } =
      typeof options === "object" ? options : { statoAssicurativo: options };

    const validationErrors = {};
    fields.forEach((field) => {
      const value = data[field.name];
      if (
        field.required &&
        (value === undefined ||
          value === null ||
          value === "" ||
          (typeof value === "object" && value.value === ""))
      ) {
        validationErrors[field.name] = "Campo obbligatorio";
      }

      if (
        field.type === "select" &&
        lookups[field.name] &&
        lookups[field.name].length > 0
      ) {
        const optionValues = lookups[field.name].map((opt) =>
          opt && typeof opt === "object" ? String(opt.value) : String(opt),
        );
        const valStr = String(value ?? "");

        if (
          valStr !== "" &&
          !optionValues.includes(valStr) &&
          !(
            field.name === "nascitaComuneCodice" &&
            data.nascitaStatoEstero === 1
          )
        ) {
          validationErrors[field.name] = "Campo obbligatorio";
        }
      }

      if (
        (field.name === "assicurazioneProvenienza" ||
          field.name === "classeMerito" ||
          field.name === "tariffa" ||
          field.name === "dataInizioCopertura" ||
          field.name === "dataFineCopertura" ||
          field.name === "dataMora") &&
        (statoAssicurativo === 1 ||
          statoAssicurativo === 2 ||
          statoAssicurativo === 3 ||
          statoAssicurativo === -1)
      ) {
        delete validationErrors[field.name];
      }

      if (
        field.name === "nascitaComuneCodice" &&
        data.nascitaStatoEstero === 1
      ) {
        delete validationErrors[field.name];
      }

      if (field.name === "nascitaNazione" && Object.keys(data).length === 0) {
        delete validationErrors[field.name];
      }
    });
    return validationErrors;
  };

  const handleSave = async (id) => {
    setIsLoading(true);
    setIsSaving(true);
    const getSectionsWithErrors = (errorsObj) => {
      return Object.entries(errorsObj)
        .filter(([_, section]) => section && Object.keys(section).length > 0)
        .map(([sectionName]) => sectionName);
    };

    const statoAssicurativo = data.tabs[0]?.Veicolo?.idStatoAssicurativo;
    const targa = data.tabs[3]?.Portante?.Veicolo[0]?.targa;

    if (statoAssicurativo === -1) {
      if (formState.statoAssicurativo.idStatoAssicurativo === "") {
        handleSnackbar(`Inserire lo stato assicurativo`, "error");
        return;
      }
      if (
        (formState.statoAssicurativo.idStatoAssicurativo === 3 ||
          formState.statoAssicurativo.idStatoAssicurativo === 2) &&
        !validateTarga(formState.statoAssicurativo.targa)
      ) {
        handleSnackbar(`Stato Assicurativo: Targa non valida`, "error");
        return;
      }
    }

    const isPersonaGiuridica = !!data.tabs[1]?.legale;
    const clienteFields = isPersonaGiuridica
      ? personaGiuridicaClienteFields
      : personaFisicaClienteFields;

    const getFreshErrors = (currentErrors, sectionData, fields, extra) => {
      const nextErrors = { ...(currentErrors || {}) };
      fields.forEach((f) => delete nextErrors[f.name]);
      const fresh = validateFields(sectionData, fields, extra);
      return { ...nextErrors, ...fresh };
    };

    const lookupsCliente = {
      slResProvincia: provincie,
      nascitaProvincia: provincie,
      nascitaNazione: nazioni,
      nascitaComuneCodice: datiComuniNascitaCliente,
      slResComuneCodice: datiComuniCliente,
      slResCap: datiCapCliente,
      slResIndirizzoVia: toponomie,
    };

    const currentClienteErrors = getFreshErrors(
      formState.errors.Cliente,
      formState.cliente,
      clienteFields,
      { lookups: lookupsCliente },
    );

    const lookupsLegale = {
      slResProvincia: provincie,
      nascitaProvincia: provincie,
      nascitaNazione: nazioni,
      nascitaComuneCodice: datiComuniNascitaLegale,
      slResComuneCodice: datiComuniLegale,
      slResCap: datiCapLegale,
      slResIndirizzoVia: toponomie,
    };

    const currentLegaleErrors = isPersonaGiuridica
      ? getFreshErrors(
          formState.errors.Legale,
          formState.legale,
          personaGiuridicaLegaleFields,
          { lookups: lookupsLegale },
        )
      : {};

    const currentVeicoloErrors = getFreshErrors(
      formState.errors.Veicolo,
      formState.veicolo,
      veicoloFields,
      { statoAssicurativo },
    );

    // Sync errors in state
    dispatch({
      type: "set_errors",
      scope: "Cliente",
      payload: currentClienteErrors,
    });
    dispatch({
      type: "set_errors",
      scope: "Legale",
      payload: currentLegaleErrors,
    });
    dispatch({
      type: "set_errors",
      scope: "Veicolo",
      payload: currentVeicoloErrors,
    });

    const currentAllErrors = {
      ...formState.errors,
      Cliente: currentClienteErrors,
      Legale: currentLegaleErrors,
      Veicolo: currentVeicoloErrors,
    };

    const sectionsWithErrors = getSectionsWithErrors(currentAllErrors);

    if (sectionsWithErrors.length > 0) {
      handleSnackbar(
        `Ci sono errori in: ${sectionsWithErrors.join(", ")}`,
        "error",
      );
      setIsLoading(false);
      setIsSaving(false);
      return false;
    } else {
      setIsSaved(true);
      const json = {
        veicolo: {
          ...formState.veicolo,
          alimentazione: formState.veicolo.alimentazione.value,
          tariffa: formState.veicolo.tariffa.value,
          tipoVeicolo: formState.veicolo.tipoVeicolo.value,
          uso: formState.veicolo.uso.value,
          idStatoAssicurativo:
            statoAssicurativo === -1
              ? formState.statoAssicurativo.idStatoAssicurativo
              : statoAssicurativo,
        },
        cliente: {
          ...formState.cliente,
          slResIndirizzoVia: formState.cliente.slResIndirizzoVia,
        },
        legale: isPersonaGiuridica
          ? {
              ...formState.legale,
              slResIndirizzoVia: formState.legale.slResIndirizzoVia,
            }
          : {},
        idUID: idTarga,
        statoAssicurativo: {
          ...formState.statoAssicurativo,
          idStatoAssicurativo:
            statoAssicurativo === -1
              ? formState.statoAssicurativo.idStatoAssicurativo
              : statoAssicurativo,
          targa:
            formState.statoAssicurativo.targa === ""
              ? targa
              : formState.statoAssicurativo.targa,
        },
      };
      const cleanedJSON = trimAllFields(json);
      console.log(cleanedJSON);
      const token = sessionStorage.getItem("token");

      try {
        const requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            data: cleanedJSON,
          }),
        };

        const response = await fetch(
          `${API_BASE_URL}/api/rcAuto/save/${idTarga}`,
          requestOptions,
        );

        const responseData = await response.json();
        if (responseData.status === -1) {
          handleSnackbar(responseData.message, "error");
          navigate("/auth/sign-in");
        }
        if (responseData.status === 0) {
          handleSnackbar(responseData.message, "error");
        }
        if (responseData.status === 1) {
          if (id) {
            handleSnackbar(responseData.message, "success");
            return true;
          }
          handleSnackbar(responseData.message, "success");
          rcAutoGetDetails();
          return true;
        }
        return false;
      } catch (error) {
        handleSnackbar("Errore durante il salvataggio.", "error");
        return false;
      } finally {
        setIsLoading(false);
        setIsSaving(false);
      }
    }
  };

  const getTabData = useMemo(() => {
    if (!tabs) return;
    switch (formState.activeTab) {
      case "Veicolo":
        return (
          <Veicolo
            dataset={getTabDataset("Veicolo")}
            ed={data.infoAgente?.ed}
            isSaved={isSaved}
            disabledFields={disabledFields.veicolo}
            errori={data.errori}
          />
        );
      case "Cliente":
        return (
          <Cliente
            cliente={getTabDataset("Cliente")}
            legale={data.tabs[1]?.legale}
            ed={data.infoAgente?.ed}
            disabledFieldsCliente={disabledFields.cliente}
            disabledFieldsLegale={disabledFields.legale}
            isSaved={isSaved}
            lookupData={{
              nazioni,
              provincie,
              toponomie,
              datiComuniLegale,
              datiCapLegale,
              datiComuniNascitaLegale,
              datiComuniCliente,
              datiComuniNascitaCliente,
              datiCapCliente,
              contatti,
            }}
            lookupActions={{
              setDatiComuniCliente,
              setDatiCapCliente,
              setDatiComuniNascitaCliente,
              setDatiComuniLegale,
              setDatiCapLegale,
              setDatiComuniNascitaLegale,
              updateComune,
              updateCap,
            }}
          />
        );
      case "Preventivi":
        return (
          <Preventivi
            defaultTab={data.defaultSubTab} //? Aggiornare qui la tab anche per Veicolo e cliente in futuro, quando si potranno inserire altre tab
            rcAutoGetDetails={rcAutoGetDetails}
            handleSave={handleSave}
          />
        );
      case "Risk Radar":
      case "Risk radar":
        const riskRadarDataset =
          getTabDataset("Risk Radar") || getTabDataset("Risk radar");
        return <RiskRadar dataset={riskRadarDataset} fullData={data} />;
      case "Portante":
        return (
          <Portante
            dataset={getTabDataset("Portante")}
            legale={data.tabs[1]?.legale}
          />
        );
      case "Altri Rami":
        return "Tab under development";
      case "Controlli":
        return <Controlli />;
      case "Polizza":
        return <Polizze />;
      case "Persona":
        return <>Persona</>;
      default:
        return <>Tab non esistente</>;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    tabs,
    formState,
    disabledFields,
    isSaved,
    nazioni,
    provincie,
    toponomie,
    datiComuniLegale,
    datiCapLegale,
    datiComuniNascitaLegale,
    datiComuniCliente,
    datiComuniNascitaCliente,
    datiCapCliente,
    contatti,
    data,
  ]);

  const renderTabs = () => {
    if (!tabs || typeof tabs !== "object") {
      return null;
    }

    return Object.keys(tabs).map((tabName, index) => (
      <Tab label={tabName} value={tabName} key={index} />
    ));
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
    setCurrenRef(null);
  };

  const renderButtons = (buttons) => {
    if (!buttons) {
      return null;
    }

    return buttons.map((button, index) => {
      const ref = (el) => {
        if (el) buttonRef.current[button] = el;
      };
      return (
        <Fragment key={index}>
          <PopoverButtons
            handleClosePopup={handleClosePopup}
            isRebootPopoverOpen={
              isPopupOpen && currentRef === buttonRef.current[button]
            }
            rebootRef={buttonRef.current[button]}
            handleAccept={() => handleClickButton(button)}
          />
          <Tooltip
            key={index}
            title={
              button === "sV"
                ? "Salva"
                : button === "rT"
                ? "Rilancia Visura"
                : "Rilancia Preventivi"
            }
          >
            <Button
              variant="contained"
              sx={{ gap: 2 }}
              ref={ref}
              onClick={() => {
                setIsPopupOpen(true); // Open the popover
                setCurrenRef(buttonRef.current[button]); // Set the correct reference
              }}
            >
              {button === "sV" ? (
                <Save />
              ) : (
                (button === "rT" || button === "rP") && <RestartAltIcon />
              )}
              {button === "sV"
                ? "Salva"
                : button === "rT"
                ? "Rilancia Visura"
                : "Rilancia Preventivi"}
            </Button>
          </Tooltip>
        </Fragment>
      );
    });
  };

  const handleAgentClick = () => {
    const agentId = data?.infoAgente?.iduid;
    console.log(agentId);
    if (agentId) {
      navigate(`/pages/profile/${agentId}`);
    }
  };

  function trimAllFields(obj) {
    if (Array.isArray(obj)) {
      return obj.map((item) => trimAllFields(item));
    } else if (obj !== null && typeof obj === "object") {
      return Object.fromEntries(
        Object.entries(obj).map(([key, value]) => [key, trimAllFields(value)]),
      );
    } else if (typeof obj === "string") {
      return obj.trim();
    }
    return obj;
  }

  return (
    <>
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            gap: 2,
            backgroundColor: "cornflower",
          }}
        >
          <CircularProgress />
          {isSaving && (
            <Typography variant="h5" gutterBottom display="inline">
              Salvataggio in corso...
            </Typography>
          )}
        </Box>
      ) : (
        <>
          <Helmet title="Profile" />
          <Box
            display="flex"
            alignItems={isMobile ? "start" : "center"}
            flexDirection={isMobile ? "column" : "row"}
            justifyContent="space-between"
            gap={4}
          >
            <Box display="flex">
              <Button
                onClick={() => {
                  const fromPath = location.state?.fromPath;
                  if (fromPath) {
                    navigate(fromPath, { state: { fromDetails: true } });
                  } else {
                    navigate(-1);
                  }
                }}
              >
                <ChevronLeft />
              </Button>
              <Box display="flex" flexDirection="column" gap="4">
                <Typography variant="h3" gutterBottom display="inline">
                  {veicolo.targa}
                </Typography>
                <Typography variant="p" gutterBottom display="inline">
                  {veicolo.marca} {veicolo.modello} {veicolo.allestimento}
                </Typography>
              </Box>
            </Box>
            <Box display="flex" gap={2}>
              <Avatar
                alt={`${data?.infoAgente?.Nome} ${data?.infoAgente?.Cognome}`}
                src={data?.infoAgente?.Avatar}
                sx={{ background: "#ff5722" }}
              />
              <div>
                <Typography variant="h6">
                  <Link
                    component="button"
                    variant="body1"
                    onClick={handleAgentClick}
                  >
                    {data?.infoAgente?.Nome} {data?.infoAgente?.Cognome}
                  </Link>
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {data?.infoAgente?.azienda}
                </Typography>
              </div>
            </Box>
          </Box>

          <Divider my={4} />
          {data?.errori != {} &&
            data?.errori?.map((error) => (
              <Alert
                key={error.idErrore}
                severity="warning"
                variant="outlined"
                sx={{ mb: 2 }}
              >
                <AlertTitle>{error.azione}</AlertTitle>
              </Alert>
            ))}
          <Grid container spacing={6}>
            <Grid item xs={12} lg={4} xl={3}>
              <Box display="flex" mb={4} gap={4} flexWrap="wrap">
                {data?.ac?.length > 0 && renderButtons(data?.ac)}
              </Box>

              <Card sx={{ display: { xs: "none", xl: "block" } }}>
                {/* <Details cliente={data.cliente} /> */}
                <ClienteCard
                  cliente={data.tabs[1]?.Cliente}
                  legale={data.tabs[1]?.legale}
                />
                <Contatti contatti={data.tabs[1]?.Cliente?.contatti} />
                <Legale legale={data.tabs[1]?.legale} />
                <VeicoloCard veicolo={data?.tabs[0]?.Veicolo?.Veicolo[0]} />
                <StatoAssicurativo
                  veicolo={data?.tabs[0]?.Veicolo?.Veicolo[0]}
                />
              </Card>
            </Grid>
            <Grid item xs={12} lg={8} xl={9}>
              <TabsWrapper>
                <Tabs
                  value={formState.activeTab}
                  onChange={handleTabChange}
                  indicatorColor="primary"
                  textColor="primary"
                  variant="scrollable"
                  scrollButtons="auto"
                  allowScrollButtonsMobile
                  aria-label="scrollable force tabs example"
                >
                  {renderTabs()}
                </Tabs>
                <Divider />
                <TabContent sx={{ backgroundColor: "yellow", width: "100vw" }}>
                  {getTabData}
                </TabContent>
              </TabsWrapper>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

const RCAutoDetailsProfile = () => (
  <FormRCAutoDetailsProvider>
    <RCAutoDetailsProfileComponent />
  </FormRCAutoDetailsProvider>
);

export default RCAutoDetailsProfile;
